<template>
  <v-data-table :headers="headers" :items="GetCategory" height="inherit" item-key="Category_Name" class="elevation-1" >
    <template v-slot:headers="props">
      <tr>
        <th v-for="header in props.headers" :key="header.text">
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr>
        <td class="text-xs-center">{{ props.item.Category_Name }}</td>
        <td class="text-xs-center">
          <v-btn color="primary" icon class="btnAction" @click="OpenUpdateCategoryModal(props.item)">
              <v-icon>edit</v-icon>
          </v-btn>
          <v-btn color="error" icon class="btnAction" @click="RemoveCategory(props.item)">
              <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
export default {
  data() {
    return {
      pagination: { sortBy: "Category_Name" },
      headers: [
        { text: "Category Name", value: "Category_Name" },
        { text: "Actions" }
      ]
    };
  },
  computed: {
    GetCategory() {
      return this.$store.getters.GetCategoryList;
    }
  },
  methods: {
    SelectAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.GetCategory.slice();
    },
    SelectIndividual(item) {
      let index = this.GetCategory.find(
        x => x["Category_Name"] == item["Category_Name"]
      );
      this.selected.push(this.GetCategory.slice(index, index + 1)[0]);
    },
    SortColumn(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    OpenUpdateCategoryModal(Item) {
      this.$emit("UpdateCategory", Item);
    },
    RemoveCategory(item) {
      if (confirm("Do you really want to delete?")) {
      this.$http
        .post(
          `${this.$store.getters.GetProductionUrl}/category/deletecategory`,
          item
        )
        .then(response => {
          this.$store.commit(
            "DeleteIndividualCategory",
            response["data"]["data"]
          );
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Successfully Deleted Category",
            Color: "green",
            Close: false
          });
          this.selected = [];
        })
        .catch(err => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Error While Removing Category",
            Color: "red",
            Close: false
          });
        });
    }
    }
  },
  mounted() {
    
    this.$http
      .get(`${this.$store.getters.GetProductionUrl}/category/getcategorylist`)
      .then(response => {
        this.$store.commit("SetCategoryList", response["data"]["response"]);
      })
      .catch(err => {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Error While Fetching Data",
          Color: "red",
          Close: false
        });
      });
  }
};
</script>
<style scoped>
  .btnAction{
      margin: 4px;
      border: 1px solid #d3d3d37a;
  }
</style>